module.exports = __webpack_public_path__ + "media/packs/components/weployer/jobTypeSelectionModal/direct_illustration-62c67425d9d5ffd4f203f25a5d2fe558.svg";